// BootstrapのJavaScript側の機能を読み込む
import "bootstrap";

// スタイルシートを読み込む
import "./index.scss";

// ヘッダーのスクロール制御を読み込む
import "./header-scroll";

// サイドバーアコーディオン機能を読み込む
import initSidebarAccordion from "./sidebar-accordion";

/**
 * Drawer.js ナビゲーションの初期化
 * サブメニューのアコーディオン動作を実装
 */
function initDrawerNavigation($) {
    if (!$ || !$.fn.drawer) {
        console.warn('jQuery または Drawer.js が読み込まれていません');
        return;
    }

    // Drawer.js の初期化
    $('.drawer').drawer();

    // 現在のページの親メニューのキャレットを開いた状態にする
    $('.current-menu-parent .caret').addClass('open');

    // サブメニューのドロップダウントグル処理
    $('.drawer-menu .dropdown-toggle[data-drawer-toggle="true"]').on('click.drawer', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(this);
        const $submenu = $this.next('.dropdown-menu');
        const $caret = $this.find('.caret');
        const isExpanded = $this.attr('aria-expanded') === 'true';

        // サブメニューをスライドトグル
        $submenu.slideToggle(300);

        // キャレットの開閉状態を切り替え
        $caret.toggleClass('open');

        // アクセシビリティ用の開閉状態
        $this.attr('aria-expanded', (!isExpanded).toString());
    });
}

// メガメニューのホバー制御（デスクトップのみ）
document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 1200) {
        const dropdowns = document.querySelectorAll('.dropdown');

        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('mouseenter', function () {
                const menu = this.querySelector('.dropdown-menu');
                if (menu) {
                    menu.style.display = 'block';
                    // 少し遅延してアニメーションクラスを追加
                    setTimeout(() => {
                        menu.classList.add('show');
                    }, 10);
                }
            });

            dropdown.addEventListener('mouseleave', function () {
                const menu = this.querySelector('.dropdown-menu');
                if (menu) {
                    menu.classList.remove('show');
                    // アニメーション完了後に非表示
                    setTimeout(() => {
                        if (!menu.classList.contains('show')) {
                            menu.style.display = 'none';
                        }
                    }, 300);
                }
            });
        });
    }

    // Drawer.js ナビゲーション初期化
    initDrawerNavigation(window.jQuery);

    // サイドバーアコーディオン初期化
    initSidebarAccordion();

    // ---------- アクセスが多いページのご案内機能 ----------
    const popularPages = document.getElementById('popular-pages');
    const popularPagesClose = document.querySelector('.popular-pages-close');
    const popularPagesRow = document.querySelector('.bg-light.row');
    let isVisible = false;

    if (popularPages) {
        // ×/+ボタンで開閉トグル
        if (popularPagesClose) {
            popularPagesClose.addEventListener('click', function () {
                popularPages.classList.toggle('expanded');

                // bg-light rowの表示/非表示を切り替え
                if (popularPagesRow) {
                    popularPagesRow.classList.toggle('show');
                }
            });
        }

        // スクロール時の表示/非表示制御
        let scrollTimeout;

        window.addEventListener('scroll', function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function () {
                const scrollY = window.scrollY || window.pageYOffset;

                // 630px以上スクロールしたら表示
                if (scrollY > 630 && !isVisible) {
                    popularPages.classList.add('visible');
                    isVisible = true;
                }

                // 上方向にスクロールして630px以内に入ったら非表示
                if (scrollY < 630 && isVisible) {
                    popularPages.classList.remove('visible');
                    popularPages.classList.remove('expanded');
                    // bg-light rowも非表示に
                    if (popularPagesRow) {
                        popularPagesRow.classList.remove('show');
                    }
                    isVisible = false;
                }
            }, 100);
        });

        // ESCキーで閉じる
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && popularPages.classList.contains('expanded')) {
                popularPages.classList.remove('expanded');
                // bg-light rowも閉じる
                if (popularPagesRow) {
                    popularPagesRow.classList.remove('show');
                }
            }
        });
    }

    // ---------- 資料請求・来場予約 下部固定ボタン（モバイルのみ） ----------
    const fixedBottomCTA = document.getElementById('fixed-bottom-cta');
    let ctaIsVisible = false;
    let scrollY = 0;

    if (fixedBottomCTA) {
        let scrollTimeout;

        window.addEventListener('scroll', function () {
            // 768px未満（モバイル）でのみスクロール制御を実行
            if (window.innerWidth < 768) {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(function () {
                    scrollY = window.scrollY || window.pageYOffset;

                    // 300px以上スクロールしたら表示
                    if (scrollY > 300 && !ctaIsVisible) {
                        fixedBottomCTA.style.display = 'block';
                        setTimeout(() => {
                            fixedBottomCTA.classList.add('show');
                        }, 10);
                        ctaIsVisible = true;
                    }

                    // 300px未満なら非表示
                    if (scrollY < 300 && ctaIsVisible) {
                        fixedBottomCTA.classList.remove('show');
                        setTimeout(() => {
                            fixedBottomCTA.style.display = 'none';
                        }, 300);
                        ctaIsVisible = false;
                    }
                }, 100);
            } else {
                // デスクトップ（768px以上）では固定ボタンを非表示
                if (ctaIsVisible) {
                    fixedBottomCTA.classList.remove('show');
                    fixedBottomCTA.style.display = 'none';
                    ctaIsVisible = false;
                }
            }
        });

        // ウィンドウリサイズ時の対応
        window.addEventListener('resize', function () {
            if (window.innerWidth >= 768 && ctaIsVisible) {
                // デスクトップサイズになったら固定ボタンを非表示
                fixedBottomCTA.classList.remove('show');
                fixedBottomCTA.style.display = 'none';
                ctaIsVisible = false;
            }
        });
    }

    // ---------- イベント予約フォームの制御 ----------
    initEventFormControl();
});

/**
 * イベント予約フォームの制御
 * URL引数の有無でフィールドの表示を切り替える
 */
function initEventFormControl() {
    const params = new URLSearchParams(location.search);
    const hasPrefill = params.has('post_id') || params.has('event');

    const eventField = document.querySelector('[name="event"]');
    const eventTextWrap = document.getElementById('event-text-wrap');
    const eventSelectWrap = document.getElementById('event-select-wrap');
    const eventSelect = document.querySelector('[name="event_select"]');

    if (!eventField || !eventTextWrap || !eventSelectWrap) {
        return; // 必要な要素が見つからない場合は終了
    }

    if (hasPrefill) {
        // URL引数がある場合：テキストフィールド表示、セレクト非表示
        eventTextWrap.style.display = 'block';
        eventSelectWrap.style.display = 'none';

        // テキストフィールドを読み取り専用にする
        if (eventField) {
            eventField.readOnly = true;
            eventField.style.backgroundColor = '#f8f9fa';
            eventField.placeholder = 'イベント名（自動入力済み）';
        }
    } else {
        // URL引数がない場合：セレクト表示、テキストフィールド非表示
        eventTextWrap.style.display = 'none';
        eventSelectWrap.style.display = 'block';

        // セレクトの変更時にテキストフィールドに値をコピー
        if (eventSelect && eventField) {
            eventSelect.addEventListener('change', function () {
                eventField.value = this.value;
            });
        }
    }
}

/*
** MW WP Form 送信ボタン動的制御
** 必須項目の入力状態に応じて送信ボタンのvalueを動的に変更
*/

/**
 * 必須フィールドのバリデーション
 * @returns {boolean} すべての必須項目が入力されているかどうか
 */
function validateRequiredFields() {
    // 必須テキストフィールドのリスト
    const requiredTextFields = [
        'contact_name',      // お名前
        'contact_kana',      // フリガナ
        'zip',               // 郵便番号
        'addr',              // 市区町村
        'contact_tel',       // 電話番号
        'contact_email'      // メールアドレス
    ];

    // 必須セレクトフィールドのリスト
    const requiredSelectFields = [
        'pref'               // 都道府県
    ];

    // 必須チェックボックスフィールドのリスト
    const requiredCheckboxFields = [
        'building_area',      // 建築予定エリア
        'referral_source'      // COCONハウスを知ったきっかけ
    ];

    // テキストフィールドのバリデーション
    for (const fieldName of requiredTextFields) {
        const field = document.querySelector(`[name="${fieldName}"]`);
        const value = field ? field.value.trim() : '';
        if (!field || !value) {
            return false;
        }
    }

    // セレクトフィールドのバリデーション
    for (const fieldName of requiredSelectFields) {
        const field = document.querySelector(`[name="${fieldName}"]`);
        const value = field ? field.value : '';
        if (!field || !value || value === ':選択してください') {
            return false;
        }
    }

    // チェックボックスフィールドのバリデーション
    for (const fieldName of requiredCheckboxFields) {
        // MW WP Formが生成する実際の形式に対応
        const checkboxes = document.querySelectorAll(`[name="${fieldName}[data][]"]`);
        let isChecked = false;

        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                isChecked = true;
            }
        });

        if (!isChecked) {
            return false;
        }
    }

    return true;
}

/**
 * 来場予約フォーム専用：必須フィールドのバリデーション
 * @returns {boolean} すべての必須項目が入力されているかどうか
 */
function validateReservationRequiredFields() {
    // 必須テキストフィールドのリスト
    const requiredTextFields = [
        'reserve_name',      // お名前
        'reserve_kana',      // フリガナ
        'zip',               // 郵便番号
        'addr',              // 市区町村
        'reserve_tel',       // 電話番号
        'reserve_email'      // メールアドレス
    ];

    // 必須セレクトフィールドのリスト
    const requiredSelectFields = [
        'preferred_time_1',  // ご希望時間（第1希望）
        'pref'               // 都道府県
    ];

    // 必須数値入力フィールドのリスト
    const requiredNumberFields = [
        'visitor_adult'      // 来場人数（大人）
    ];

    // 必須日付フィールドのリスト
    const requiredDateFields = [
        'preferred_date_1'   // ご希望日（第1希望）
    ];

    // 必須チェックボックスフィールドのリスト
    const requiredCheckboxFields = [
        'building_area'      // 建築予定エリア
    ];

    // テキストフィールドのバリデーション
    for (const fieldName of requiredTextFields) {
        const field = document.querySelector(`[name="${fieldName}"]`);
        if (!field || !field.value.trim()) {
            return false;
        }
    }

    // セレクトフィールドのバリデーション
    for (const fieldName of requiredSelectFields) {
        const field = document.querySelector(`[name="${fieldName}"]`);
        if (!field || !field.value || field.value === ':選択してください') {
            return false;
        }
    }

    // 数値入力フィールドのバリデーション
    for (const fieldName of requiredNumberFields) {
        const field = document.querySelector(`[name="${fieldName}"]`);
        if (!field || !field.value || parseInt(field.value) < 1) {
            return false;
        }
    }

    // 日付フィールドのバリデーション
    for (const fieldName of requiredDateFields) {
        const field = document.querySelector(`[name="${fieldName}"]`);
        if (!field || !field.value.trim()) {
            return false;
        }
    }

    // チェックボックスフィールドのバリデーション
    for (const fieldName of requiredCheckboxFields) {
        // MW WP Formが生成する実際の形式に対応
        const checkboxes = document.querySelectorAll(`[name="${fieldName}[data][]"]`);
        let isChecked = false;

        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                isChecked = true;
            }
        });

        if (!isChecked) {
            return false;
        }
    }

    // 参加希望イベントフィールドの特別処理（initEventFormControlとの連携）
    const eventField = document.querySelector('[name="event"]');
    if (eventField && !eventField.closest('.row').classList.contains('d-none')) {
        // 表示されているフィールドの場合のみ、値が設定されているかチェック
        if (!eventField.value.trim()) {
            return false;
        }
    }

    return true;
}

/**
 * フォーム種別を判定
 * @returns {string} 'contact' | 'reservation' | 'unknown'
 */
function detectFormType() {
    // 来場予約フォーム特有のフィールドが存在するかチェック
    const reservationFields = [
        'reserve_name',
        'preferred_date_1',
        'visitor_adult'
    ];

    // 資料請求フォーム特有のフィールドが存在するかチェック
    const contactFields = [
        'contact_name',
        'contact_tel'
    ];

    const hasReservationFields = reservationFields.some(fieldName =>
        document.querySelector(`[name="${fieldName}"]`)
    );

    const hasContactFields = contactFields.some(fieldName =>
        document.querySelector(`[name="${fieldName}"]`)
    );

    if (hasReservationFields) {
        return 'reservation';
    } else if (hasContactFields) {
        return 'contact';
    }

    return 'unknown';
}

/**
 * 送信ボタンの状態を更新（両フォーム対応）
 */
function updateSubmitButton() {
    const submitButton = document.querySelector('[name="submit_request"]');

    if (!submitButton) {
        return;
    }

    // フォーム種別を判定して適切なバリデーション関数を実行
    const formType = detectFormType();

    let isValid = false;

    switch (formType) {
        case 'contact':
            isValid = validateRequiredFields();
            break;
        case 'reservation':
            isValid = validateReservationRequiredFields();
            break;
        default:
            isValid = validateRequiredFields() || validateReservationRequiredFields();
            break;
    }

    if (isValid) {
        // すべての必須項目が入力済み
        submitButton.value = '送信する';
        submitButton.classList.remove('btn-secondary');
        submitButton.classList.add('btn-primary');
        submitButton.disabled = false;
    } else {
        // 必須項目が未入力
        submitButton.value = '必須未入力';
        submitButton.classList.remove('btn-primary');
        submitButton.classList.add('btn-secondary');
        submitButton.disabled = true;
    }
}

/**
 * フォームバリデーション機能の初期化（両フォーム対応）
 */
function setupFormValidation() {
    // フォーム要素が存在するか確認
    const form = document.querySelector('.mw_wp_form');
    const submitButton = document.querySelector('[name="submit_request"]');

    if (!form || !submitButton) {
        return; // フォームまたは送信ボタンが存在しない場合は処理を終了
    }

    // フォーム種別を判定
    const formType = detectFormType();

    // 監視対象フィールドのセレクターを動的に設定
    let fieldSelectors = [];

    if (formType === 'contact') {
        // 資料請求フォーム用のフィールド
        fieldSelectors = [
            '[name="contact_name"]',
            '[name="contact_kana"]',
            '[name="zip"]',
            '[name="pref"]',
            '[name="addr"]',
            '[name="contact_tel"]',
            '[name="contact_email"]',
            '[name="building_area[data][]"]',
            '[name="referral_source[data][]"]'
        ];
    } else if (formType === 'reservation') {
        // 来場予約フォーム用のフィールド
        fieldSelectors = [
            '[name="preferred_date_1"]',
            '[name="preferred_time_1"]',
            '[name="preferred_date_2"]',
            '[name="preferred_time_2"]',
            '[name="reserve_name"]',
            '[name="reserve_kana"]',
            '[name="visitor_adult"]',
            '[name="zip"]',
            '[name="pref"]',
            '[name="addr"]',
            '[name="building_area[data][]"]',
            '[name="reserve_tel"]',
            '[name="reserve_email"]',
            '[name="referral_source[data][]"]'
        ];
    } else {
        // 不明な場合は両方のフィールドを監視
        fieldSelectors = [
            // 資料請求フォーム用
            '[name="contact_name"]',
            '[name="contact_kana"]',
            '[name="contact_tel"]',
            '[name="contact_email"]',
            // 来場予約フォーム用
            '[name="event"]',
            '[name="preferred_date_1"]',
            '[name="preferred_time_1"]',
            '[name="reserve_name"]',
            '[name="reserve_kana"]',
            '[name="visitor_adult"]',
            '[name="reserve_tel"]',
            '[name="reserve_email"]',
            // 共通フィールド
            '[name="zip"]',
            '[name="pref"]',
            '[name="addr"]',
            '[name="building_area[]"]'
        ];
    }

    // 各フィールドにイベントリスナーを設定
    fieldSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);

        elements.forEach((element) => {
            // テキストフィールド・メールフィールド・セレクトフィールド・日付フィールド
            if (element.type === 'text' ||
                element.type === 'email' ||
                element.type === 'date' ||
                element.type === 'number' ||
                element.tagName === 'SELECT') {
                element.addEventListener('input', updateSubmitButton);
                element.addEventListener('change', updateSubmitButton);
                element.addEventListener('blur', updateSubmitButton);
            }
            // チェックボックス
            else if (element.type === 'checkbox') {
                element.addEventListener('change', updateSubmitButton);
            }
        });
    });

    // 初期状態での送信ボタン更新
    updateSubmitButton();
}

/**
 * デバッグ用関数 - ブラウザのコンソールから手動実行可能
 */
window.debugFormValidation = function() {
    console.log('🐛 === デバッグ開始 ===');

    // フォーム種別判定
    const formType = detectFormType();
    console.log('🔍 フォーム種別:', formType);

    // フォーム要素の存在確認
    const form = document.querySelector('.mw_wp_form');
    const submitButton = document.querySelector('[name="submit_request"]');
    console.log('📋 フォーム要素:', form);
    console.log('🔘 送信ボタン:', submitButton);

    // 資料請求フォームのバリデーション実行
    if (formType === 'contact' || formType === 'unknown') {
        console.log('\n📝 === 資料請求フォームバリデーション ===');
        const contactValid = validateRequiredFields();
        console.log('結果:', contactValid);
    }

    // 送信ボタン更新実行
    console.log('\n🔄 === 送信ボタン更新 ===');
    updateSubmitButton();

    console.log('🐛 === デバッグ終了 ===\n');
};

// MW WP Formバリデーション機能の動的生成対応初期化
document.addEventListener('DOMContentLoaded', function () {
    setupFormValidation();

    // MW WP Formが動的にフォームを生成する場合のための再初期化
    // MutationObserverを使用してDOM変更を監視
    const validationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
                // フォーム要素が追加された可能性があるので再初期化
                setupFormValidation();
            }
        });
    });

    // フォームコンテナを監視（存在する場合）
    const formContainer = document.querySelector('.mw_wp_form');
    if (formContainer) {
        validationObserver.observe(formContainer, {
            childList: true,
            subtree: true
        });
    }
});
